import { defaultLanguage, languages } from "../i18n";

const getTranslatedPath = (pathname, to) => {
    if (to === 'https://blog.decenter.com/') return to;
    if (to === '#contact') return `${pathname}${to}`;
    const currentPageLanguage = getCurrentPageLanguage(pathname);
    const toLanguage = getCurrentPageLanguage(to);

    let outputPath = to;
    if (currentPageLanguage !== toLanguage) {

        let languagePath = '';
        const isDefaultLanguage = defaultLanguage === currentPageLanguage;
        if (!isDefaultLanguage) {
            languagePath = '/' + currentPageLanguage
        }

        outputPath = `${languagePath}${to}`;
    }
    const hasTrailingSlash = outputPath.endsWith("/");

    const isAttribute = outputPath.search(/#\w+$/g);
    if (!hasTrailingSlash && isAttribute === -1) {
        outputPath += "/";
    }
    return outputPath;
}

const getCurrentPageLanguage = (pathname) => {
    const pathElements = pathname.split("/");
    for (let element of pathElements) {
        for (let language of languages) {
            if (element === language) {
                return language;
            }
        }
    }
    return defaultLanguage;
};

export const setLanguage = (lang) => {
    const currentLanguage = getCurrentPageLanguage(window.location.pathname);
    if (currentLanguage === lang) { return; }
    const pathWithLanguageHref = window.location.href.split('/');

    if (currentLanguage === 'en') {
        pathWithLanguageHref.splice(3, 0, lang);

        return pathWithLanguageHref.join('/');
    }

    if (lang === 'en') {
        pathWithLanguageHref.splice(3, 1);
    } else {
        pathWithLanguageHref.splice(3, 1, lang);
    }

    return pathWithLanguageHref.join('/');
}

// export const getRouteMeta = (pathname) => {
// }

export const EMAIL_REGEX =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

export const validateForm = errors => {
    let valid = true;
    Object.values(errors).forEach(val => val.length > 0 && (valid = false));
    return valid;
};

export const sendRequest = async (name, email, message, recaptcha) => {
    const res = await fetch(`https://www.decenter.com:443/api/contact?name=${name}&email=${email}&message=${message}&g-recaptcha-response=${recaptcha}`, {
        method: 'GET',
    });

    if (!res.ok) throw new Error(await res.text());
}

export {getTranslatedPath, getCurrentPageLanguage};

export const createId = (name) => name.toLowerCase()
.replaceAll(' / ', ' ')
.replaceAll(' ', '-');
